module.exports = __webpack_public_path__ + "resource/img/banner_tracking.jpg?295a9133c4b1990a24aa88590dee31ca";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_tracking.jpg
// module id = 191
// module chunks = 36